// Recherche insensible à la casse et aux accents, partagée par `searchable_select_controller.js` et
// `autocomplete_input_controller.js` : une seule règle de correspondance, un seul découpage du gras.

// Repli : minuscules + décomposition NFD + retrait des marques combinantes (U+0300–U+036F), « belair »
// trouve « Bélair ». Limite connue : les ligatures (œ, æ) ne se décomposent pas, « oeuf » ne trouve pas « œuf ».
export const fold = (s) =>
  s
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

const COMBINING_MARK = /[\u0300-\u036f]/;

// Où `query` (déjà replié) se trouve dans `text`, en positions [début, fin) du texte ORIGINAL, ou null.
// Le repli se fait caractère par caractère avec une table de positions, car fold() peut changer la
// longueur (un libellé décomposé en NFD, une minuscule qui s'allonge) : un indice trouvé dans le texte
// replié n'est pas un indice dans le libellé.
export const foldedRange = (text, query) => {
  let folded = '';
  const starts = [];
  const ends = [];
  let offset = 0;
  for (const ch of text) {
    const piece = fold(ch);
    for (let k = 0; k < piece.length; k += 1) {
      starts.push(offset);
      ends.push(offset + ch.length);
    }
    folded += piece;
    offset += ch.length;
  }
  const at = query === '' ? -1 : folded.indexOf(query);
  if (at < 0) return null;

  let end = ends[at + query.length - 1];
  // Un accent décomposé se replie en rien : il reste dans la <mark> avec sa lettre.
  while (end < text.length && COMBINING_MARK.test(text[end])) end += 1;
  return [starts[at], end];
};
